var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ContentWordLimitOptions, ContextOptions, SubTypeOptions, ToneOptions, } from '@/compositions/useDefaultOptions';
import { fieldsMapping } from '@/compositions/useFormFields';
import { getFormRules } from '@/compositions/useFormRules';
import { useNotification } from '@/compositions/useNotification';
import { CUSTOM_CONTENT_LENGTH, PENDO_MODULE_EVENT_NAME } from '@/helper/const';
import { i18n } from '@/locales';
import { UICollapse, UICollapseItem, UIDynamicTags, UIForm, UIFormItem, UIInput, UIModal, UIModalContent, UIModalFooter, UIModalHeader, UISelect, UISpace, } from '@gohighlevel/ghl-ui';
import { computed, h, inject, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { ContentAIServices } from '../../service/ContentAIService';
import { ContentWordLimitKeys, FormFieldNames, FormFieldTitle, ModuleType, SubType, } from '../../types/';
import UINumberOfVariations from '../common/UINumberOfVariations.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalGenerateVariations',
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        productType: {
            type: String,
            require: true,
        },
        subType: {
            type: String,
            default: '',
        },
        formData: {
            type: Object,
            default: function () {
                return {
                    title: '',
                    description: '',
                    keywords: [],
                    tone: '',
                    numberOfVariations: 3,
                    subType: '',
                    emailContext: '',
                    lengthOfContent: ContentWordLimitKeys.SMALL,
                    customLengthOfContent: CUSTOM_CONTENT_LENGTH.DEFAULT,
                };
            },
        },
        pendoProperties: {
            type: Object,
        },
    },
    emits: ['close', 'showVariations'],
    setup(__props, { emit }) {
        const props = __props;
        const notification = useNotification();
        const { t } = useI18n();
        const store = inject('store');
        const route = inject('route');
        const user = inject('user');
        const emitter = inject('emitter');
        const show = computed(() => props.showModal);
        const source = computed(() => props.productType);
        const rules = computed(() => getFormRules(props.productType));
        const formFields = computed(() => fieldsMapping[`${props.productType}_${props.subType}`]
            ? fieldsMapping[`${props.productType}_${props.subType}`]
            : fieldsMapping[props.productType]);
        const subType = computed(() => props.subType);
        const disableAction = computed(() => {
            return (formFields.value.required.filter((field) => {
                if (field === 'keywords' && !formValue.value[field].length) {
                    return true;
                }
                else if (field === 'numberOfVariations' && !formValue.value[field]) {
                    return true;
                }
                else if (field === 'lengthOfContent' &&
                    formValue.value[field] === ContentWordLimitKeys.CUSTOM) {
                    const customLength = Number(formValue.value.customLengthOfContent);
                    const isInvalidCustomLength = !customLength ||
                        customLength < CUSTOM_CONTENT_LENGTH.MIN ||
                        customLength > CUSTOM_CONTENT_LENGTH.MAX;
                    if (isInvalidCustomLength &&
                        (formValue.value.subType !== SubType.SECTION ||
                            props.productType !== ModuleType.BLOGS)) {
                        return true;
                    }
                    if (isInvalidCustomLength) {
                        return true;
                    }
                }
                else {
                    return !formValue.value[field];
                }
            }).length > 0);
        });
        const contextOptions = computed(() => ContextOptions.map((opt) => {
            return Object.assign(Object.assign({}, opt), { label: t(opt.label) });
        }));
        const writingToneOptions = computed(() => ToneOptions.map((opt) => {
            return Object.assign(Object.assign({}, opt), { label: t(opt.label) });
        }));
        const subTypeOptions = computed(() => SubTypeOptions.map((opt) => {
            return Object.assign(Object.assign({}, opt), { label: t(opt.label) });
        }));
        const contentWordLimitOptions = computed(() => ContentWordLimitOptions.map((opt) => {
            return Object.assign(Object.assign({}, opt), { label: t(opt.label) });
        }));
        const lengthOfContentTooltip = {
            text: () => h('b', {}, i18n.global.t('generateContentModal.lengthOfContentTooltip')),
        };
        const modalIcon = () => h('img', {
            src: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/640769bccb193579f29147db.svg+xml',
            class: 'w-6 h-6',
        });
        watch(subType, () => {
            formValue.value.subType = props.subType;
        });
        watch(show, () => {
            formValue.value = props.formData;
            formValue.value.subType = props.subType;
        });
        const loading = ref(false);
        const errorMessage = ref([]);
        const root = ref();
        const dropDownContainer = ref();
        const formValue = ref({
            title: '',
            description: '',
            keywords: [],
            tone: '',
            numberOfVariations: 3,
            subType: props.subType,
            emailContext: '',
            lengthOfContent: ContentWordLimitKeys.SMALL,
            customLengthOfContent: CUSTOM_CONTENT_LENGTH.DEFAULT,
        });
        function closeModal() {
            if (loading.value)
                return;
            emit('close');
            clearFormField();
        }
        function clearFormField() {
            formValue.value = {
                title: '',
                description: '',
                keywords: [],
                tone: '',
                numberOfVariations: 3,
                subType: subType.value,
                emailContext: '',
                lengthOfContent: ContentWordLimitKeys.SMALL,
                customLengthOfContent: CUSTOM_CONTENT_LENGTH.DEFAULT,
            };
        }
        function errorHandler(errorMsg, statusCode) {
            if (statusCode === 422 && Array.isArray(errorMsg)) {
                const fields = [...formFields.value.required, ...formFields.value.optional];
                for (const field of fields) {
                    const error = errorMsg.filter(err => err.includes(field));
                    if (error.length) {
                        const msg = error[0].replace(field, FormFieldTitle[field]);
                        errorMessage.value.push(msg);
                    }
                }
            }
            else {
                errorMessage.value.push(errorMsg);
            }
        }
        function submit() {
            root.value
                .getForm()
                .validate()
                .then(() => __awaiter(this, void 0, void 0, function* () {
                try {
                    if (loading.value)
                        return;
                    loading.value = true;
                    const data = yield generateVariationBySource();
                    if (data.id) {
                        openVariation(data.id);
                    }
                    loading.value = false;
                    emitter.emit('pendo-track-event-content-ai', {
                        event: 'Content AI ' + PENDO_MODULE_EVENT_NAME[props.productType],
                        properties: Object.assign({ is_content_ai_generated: true, content_ai_type: 'Text', number_of_variations: formValue.value.numberOfVariations, content_ai_subtype: formValue.value.subType, email_context: formValue.value.emailContext, wordLimit: formValue.value.lengthOfContent == ContentWordLimitKeys.CUSTOM
                                ? Number(formValue.value.customLengthOfContent)
                                : formValue.value.lengthOfContent }, props.pendoProperties),
                    });
                    clearFormField();
                }
                catch (error) {
                    showError(error);
                    loading.value = false;
                }
            }))
                .catch(() => {
                // do nothing
            });
        }
        function showError(error) {
            var _a, _b, _c, _d, _e;
            const errorMsg = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            errorMessage.value = [];
            errorHandler(errorMsg, (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.statusCode);
            if ((_e = errorMessage.value) === null || _e === void 0 ? void 0 : _e.length)
                notification.create({
                    type: 'error',
                    title: errorMessage.value.join('\n'),
                });
        }
        function generateVariationBySource() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const body = {
                    title: formValue.value.title.trim(),
                    description: formValue.value.description.trim(),
                    keywords: formValue.value.keywords,
                    tone: formValue.value.tone
                        ? formValue.value.tone
                        : undefined,
                    numberOfVariations: formValue.value.numberOfVariations,
                    locationId: (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id,
                    userId: user === null || user === void 0 ? void 0 : user.id,
                    companyId: store.state.company.company.id,
                    type: props.productType,
                    wordLimit: formValue.value.lengthOfContent == ContentWordLimitKeys.CUSTOM
                        ? Number(formValue.value.customLengthOfContent)
                        : formValue.value.lengthOfContent,
                };
                if (source.value !== ModuleType.SOCIAL_PLANNER) {
                    body['subType'] = formValue.value.subType;
                }
                if (formValue.value.subType == SubType.BODY) {
                    body['emailContext'] = formValue.value.emailContext;
                }
                const response = yield ContentAIServices.generateVariations(body);
                if (response.data)
                    return response.data;
                throw Error('Something went wrong, please try again');
            });
        }
        function setNumberOfVariation(variation) {
            formValue.value.numberOfVariations = variation;
        }
        function openVariation(id) {
            closeModal();
            emit('showVariations', id);
        }
        function addKeyWords(keyWords) {
            formValue.value.keywords = keyWords;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: _unref(show),
                width: 630
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "content-ai-new-content-modal-header",
                        title: _ctx.$t('generateContentModal.title'),
                        icon: modalIcon,
                        type: "custom",
                        description: _ctx.$t('common.thisIsPaidService'),
                        class: "pb-2",
                        onClose: closeModal
                    }, null, 8 /* PROPS */, ["title", "description"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        positiveText: _ctx.$t('generateContentModal.generate'),
                        negativeText: _ctx.$t('generateContentModal.clear'),
                        onPositiveClick: submit,
                        onNegativeClick: clearFormField,
                        id: "content-ai-new-modal-footer",
                        disabled: _unref(disableAction),
                        loading: loading.value
                    }, null, 8 /* PROPS */, ["positiveText", "negativeText", "disabled", "loading"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        ref_key: "dropDownContainer",
                        ref: dropDownContainer,
                        id: "content-ai-new-content-modal-form-select-context-wrapper"
                    }, null, 512 /* NEED_PATCH */),
                    _createVNode(_unref(UIModalContent), {
                        id: "content-ai-new-content-modal-content",
                        class: "overflow-y-auto",
                        style: { "max-height": "560px" }
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UIForm), {
                                ref_key: "root",
                                ref: root,
                                model: formValue.value,
                                rules: _unref(rules),
                                id: "content-ai-new-content-modal-form"
                            }, {
                                default: _withCtx(() => [
                                    (_unref(formFields).fields.includes(_unref(FormFieldNames).SUB_TYPE))
                                        ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                            key: 0,
                                            label: _ctx.$t('generateContentModal.type'),
                                            path: "subType"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UISelect), {
                                                    tag: true,
                                                    id: "content-ai-new-content-modal-form-select-subType",
                                                    value: formValue.value.subType,
                                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((formValue.value.subType) = $event)),
                                                    placeholder: _ctx.$t('generateContentModal.typePlaceholder'),
                                                    options: _unref(subTypeOptions)
                                                }, null, 8 /* PROPS */, ["value", "placeholder", "options"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]))
                                        : _createCommentVNode("v-if", true),
                                    (_unref(formFields).fields.includes(_unref(FormFieldNames).CONTEXT))
                                        ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                            key: 1,
                                            label: _ctx.$t('generateContentModal.context'),
                                            path: "emailContext"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UISelect), {
                                                    id: "content-ai-new-content-modal-form-select-context",
                                                    value: formValue.value.emailContext,
                                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((formValue.value.emailContext) = $event)),
                                                    options: _unref(contextOptions),
                                                    placeholder: _ctx.$t('generateContentModal.contextPlaceholder'),
                                                    placement: "bottom",
                                                    to: dropDownContainer.value
                                                }, null, 8 /* PROPS */, ["value", "options", "placeholder", "to"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]))
                                        : _createCommentVNode("v-if", true),
                                    (_unref(formFields).fields.includes(_unref(FormFieldNames).TITLE))
                                        ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                            key: 2,
                                            label: _ctx.$t('generateContentModal.contentTitle'),
                                            path: "title"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UIInput), {
                                                    modelValue: formValue.value.title,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formValue.value.title) = $event)),
                                                    placeholder: _ctx.$t('generateContentModal.contentTitlePlaceholder'),
                                                    id: "content-ai-new-content-modal-form-input-title"
                                                }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]))
                                        : _createCommentVNode("v-if", true),
                                    (_unref(formFields).fields.includes(_unref(FormFieldNames).DESCRIPTION))
                                        ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                            key: 3,
                                            label: _ctx.$t('generateContentModal.description'),
                                            path: "description"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UIInput), {
                                                    type: "textarea",
                                                    modelValue: formValue.value.description,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((formValue.value.description) = $event)),
                                                    placeholder: _ctx.$t('generateContentModal.descriptionPlaceholder'),
                                                    id: "content-ai-new-content-modal-form-input-description"
                                                }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]))
                                        : _createCommentVNode("v-if", true),
                                    (_unref(formFields).fields.includes(_unref(FormFieldNames).KEYWORDS))
                                        ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                            key: 4,
                                            label: _ctx.$t('generateContentModal.addKeywords'),
                                            path: "keywords"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UIDynamicTags), {
                                                    id: "content-ai-new-content-modal-form-select-keywords",
                                                    type: "default",
                                                    defaultValue: formValue.value.keywords,
                                                    max: 100,
                                                    closable: true,
                                                    round: true,
                                                    onOnUpdate: addKeyWords
                                                }, null, 8 /* PROPS */, ["defaultValue"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]))
                                        : _createCommentVNode("v-if", true),
                                    _createVNode(_unref(UISpace), { size: "large" }, {
                                        default: _withCtx(() => [
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).TONE))
                                                ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                                    key: 0,
                                                    label: _ctx.$t('generateContentModal.writingTone'),
                                                    style: { "width": "330px" },
                                                    required: true
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(UISelect), {
                                                            tag: true,
                                                            id: "content-ai-new-content-modal-form-select-tone",
                                                            value: formValue.value.tone,
                                                            "onUpdate:value": _cache[4] || (_cache[4] = ($event) => ((formValue.value.tone) = $event)),
                                                            placeholder: _ctx.$t('generateContentModal.writingTonePlaceholder'),
                                                            options: _unref(writingToneOptions)
                                                        }, null, 8 /* PROPS */, ["value", "placeholder", "options"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["label"]))
                                                : _createCommentVNode("v-if", true),
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).NUMBER_OF_VARIATIONS))
                                                ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                                    key: 1,
                                                    label: _ctx.$t('generateContentModal.numberOfVariations')
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(UINumberOfVariations, {
                                                            "number-of-variations": formValue.value.numberOfVariations,
                                                            onUpdate: setNumberOfVariation
                                                        }, null, 8 /* PROPS */, ["number-of-variations"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["label"]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_unref(UISpace), { size: "large" }, {
                                        default: _withCtx(() => [
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).LENGTH_OF_CONTENT) ||
                                                (formValue.value.subType == _unref(SubType).SECTION &&
                                                    props.productType == _unref(ModuleType).BLOGS))
                                                ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                                    key: 0,
                                                    label: _ctx.$t('generateContentModal.lengthOfContent'),
                                                    tooltip: lengthOfContentTooltip,
                                                    style: { "width": "330px" },
                                                    path: "lengthOfContent",
                                                    required: true
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(UISelect), {
                                                            tag: true,
                                                            id: "content-ai-new-content-modal-form-lengthOfContent",
                                                            value: formValue.value.lengthOfContent,
                                                            "onUpdate:value": _cache[5] || (_cache[5] = ($event) => ((formValue.value.lengthOfContent) = $event)),
                                                            placeholder: _ctx.$t('generateContentModal.lengthOfContentPlaceholder'),
                                                            options: _unref(contentWordLimitOptions)
                                                        }, null, 8 /* PROPS */, ["value", "placeholder", "options"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["label"]))
                                                : _createCommentVNode("v-if", true),
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).CUSTOM_LENGTH_OF_CONTENT) &&
                                                formValue.value.lengthOfContent == _unref(ContentWordLimitKeys).CUSTOM &&
                                                (props.productType !== _unref(ModuleType).BLOGS ||
                                                    formValue.value.subType == _unref(SubType).SECTION))
                                                ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                                    key: 1,
                                                    label: _ctx.$t('generateContentModal.customLengthOfContent'),
                                                    style: { "width": "130px" },
                                                    path: "customLengthOfContent",
                                                    required: true
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(UIInput), {
                                                            tag: true,
                                                            id: "content-ai-new-content-modal-form-customLengthOfContent",
                                                            value: formValue.value.customLengthOfContent,
                                                            "onUpdate:value": _cache[6] || (_cache[6] = ($event) => ((formValue.value.customLengthOfContent) = $event)),
                                                            placeholder: _ctx.$t('generateContentModal.customLengthOfContentPlaceholder'),
                                                            showButton: false,
                                                            size: "large"
                                                        }, null, 8 /* PROPS */, ["value", "placeholder"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["label"]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    (_unref(formFields).fields.includes(_unref(FormFieldNames).ADDITIONAL))
                                        ? (_openBlock(), _createBlock(_unref(UICollapse), { key: 5 }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UICollapseItem), {
                                                    title: _ctx.$t('generateContentModal.additionalOptions'),
                                                    name: "additional_options",
                                                    id: "content-ai-new-content-modal-form-additional_options"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(UISpace), null, {
                                                            default: _withCtx(() => [
                                                                (_unref(formFields).optional.includes(_unref(FormFieldNames).TONE))
                                                                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                                                        key: 0,
                                                                        label: _ctx.$t('generateContentModal.writingTone'),
                                                                        class: "w-[240px]",
                                                                        style: { "width": "240px" }
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_unref(UISelect), {
                                                                                tag: true,
                                                                                id: "content-ai-new-content-modal-form-select-tone",
                                                                                value: formValue.value.tone,
                                                                                "onUpdate:value": _cache[7] || (_cache[7] = ($event) => ((formValue.value.tone) = $event)),
                                                                                placeholder: _ctx.$t('generateContentModal.writingTonePlaceholder'),
                                                                                options: _unref(writingToneOptions)
                                                                            }, null, 8 /* PROPS */, ["value", "placeholder", "options"])
                                                                        ]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["label"]))
                                                                    : _createCommentVNode("v-if", true),
                                                                (_unref(formFields).optional.includes(_unref(FormFieldNames).NUMBER_OF_VARIATIONS))
                                                                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                                                        key: 1,
                                                                        label: _ctx.$t('generateContentModal.numberOfVariations')
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(UINumberOfVariations, {
                                                                                "number-of-variations": formValue.value.numberOfVariations,
                                                                                onUpdate: setNumberOfVariation
                                                                            }, null, 8 /* PROPS */, ["number-of-variations"])
                                                                        ]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["label"]))
                                                                    : _createCommentVNode("v-if", true)
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        })
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["title"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["model", "rules"])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
